import React from 'react'
import comingSoon from './images/iluv.jpg'
import './OpeningSoon.css'



function OpeningSoon() {
    return (
        <div className="coming_soon_img">
        </div>
    )
}

export default OpeningSoon
